module.exports = __webpack_public_path__ + "img/login3.2954db50.png";